package org.vreo.devicehub.features.device.presentation

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

import androidx.lifecycle.ViewModel

import org.vreo.devicehub.features.core.domain.device.device.AnprDevice

/**
 * Selected device view model, allows to pass selected device between views via navigation
 * controller
 */
class SelectedDeviceViewModel() : ViewModel() {
    private val _selectedDevice = MutableStateFlow<AnprDevice?>(null)
    val selectedDevice = _selectedDevice.asStateFlow()

    /**
     * Set the selected device
     *
     * @param device device to set as selected
     */
    fun setSelectedDevice(device: AnprDevice?) {
        _selectedDevice.value = device
    }
}